module.exports = __webpack_public_path__ + "static/media/close-icon-round.515bffb7.svg";